import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6172b4b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "opportunities-main",
  ref: "sectionMain"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "back-box" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_loading = _resolveComponent("page-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_page_loading, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: "bi bi-arrow-left-circle back-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
        })
      ]),
      _createElementVNode("iframe", {
        width: "600",
        height: "1563",
        src: _ctx.opportunityFromBiURL,
        frameborder: "0",
        class: "zero-border",
        allowfullscreen: "",
        sandbox: "allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox",
        onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleIframeLoad && _ctx.handleIframeLoad(...args)))
      }, "\n      ", 40, _hoisted_4)
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ])
  ], 512))
}